import PropTypes from 'prop-types';
import React, { Component } from 'react';


class Buttons extends Component {
    _renderResetButton () {
        let handler = () => this.props.onCancel();
        let label = 'Cancel';

        if (this.props.isCloning || this.props.isEditing) {
            handler = () => this.props.onReset();
            label = 'Reset';
        }

        return (
            <button className="btn-delete" onClick={handler}>
                {label}
            </button>
        );
    }

    _renderSaveButton () {
        const disabled = (this.props.isSubmitted && !this.props.isCloning)
              || !this.props.userCanSave;

        return (
            <button
                type="submit"
                className={(disabled) ? 'btn-disabled' : 'btn-save'}
                disabled={(disabled) ? 'disabled' : ''}
                onClick={() => this.props.onSave(false)}
            >Save</button>
        );
    }

    _renderSubmitButton () {
        return (
            <button
                className="btn-submit"
                disabled={(this.props.userCanSave) ? '' : 'disabled'}
                className={(this.props.userCanSave) ? 'btn-submit' : 'btn-disabled'}
                onClick={() => this.props.onSubmit()}
            >Submit</button>
        );
    }

    render () {
        const saveEnabled = !this.props.isSubmitted || this.props.isCloning;

        return (
            <div>
                <div className="col-sm-3 col-xs-4">
                    {this._renderSaveButton()}
                </div>
                <div className="col-sm-3 col-xs-4">
                    {this._renderSubmitButton()}
                </div>
                <div className="col-sm-3 col-sm-offset-3 col-xs-4">
                    {this._renderResetButton()}
                </div>
            </div>
        );
    }
}

Buttons.propTypes = {
    isCloning:   PropTypes.bool.isRequired,
    isEditing:   PropTypes.bool.isRequired,
    isSubmitted: PropTypes.bool.isRequired,
    onCancel:    PropTypes.func.isRequired,
    onReset:     PropTypes.func.isRequired,
    onSave:      PropTypes.func.isRequired,
    onSubmit:    PropTypes.func.isRequired,
    userCanSave: PropTypes.bool,
};

Buttons.defaultProps = { userCanSave: false };

export default Buttons;



// WEBPACK FOOTER //
// ./app/components/TimeInput/Buttons.jsx